var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHiwWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.151,
    height: 37.695,
    viewBox: "0 0 35.151 37.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.13,
    y1: 0.187,
    x2: 1,
    y2: 0.93,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8758e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9053d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-svgrepo-com_3_",
    "data-name": "wallet-svgrepo-com (3)",
    transform: "translate(-6.648 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(6.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M39.217,9.548h-.531V2.333A2.335,2.335,0,0,0,36.353,0H35.325l-.113.009C27.406,1.3,9.213,6.725,9.035,6.778A2.761,2.761,0,0,0,6.9,9.9v24.96a2.336,2.336,0,0,0,2.333,2.332H39.217a2.335,2.335,0,0,0,2.332-2.332V11.88A2.334,2.334,0,0,0,39.217,9.548ZM9.43,8.114c.181-.055,18.2-5.433,25.952-6.723h.971a.943.943,0,0,1,.942.941V9.548H9.231a2.305,2.305,0,0,0-.939.2C8.294,8.96,8.36,8.427,9.43,8.114ZM40.157,27.894H31a.945.945,0,0,1-.941-.943V22.314A.943.943,0,0,1,31,21.373h9.153ZM31,19.982a2.336,2.336,0,0,0-2.332,2.332v4.637A2.335,2.335,0,0,0,31,29.283h9.153v5.58a.942.942,0,0,1-.941.941H9.231a.943.943,0,0,1-.941-.941V11.88a.943.943,0,0,1,.941-.941H39.217a.941.941,0,0,1,.941.941v8.1Z",
    transform: "translate(-6.898)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12_-_Outline",
    "data-name": "Path 12 - Outline",
    d: "M35.315-.25h1.038a2.586,2.586,0,0,1,2.583,2.583V9.3h.281A2.585,2.585,0,0,1,41.8,11.88V34.863a2.585,2.585,0,0,1-2.582,2.582H9.231a2.585,2.585,0,0,1-2.583-2.582V9.9A3.008,3.008,0,0,1,8.965,6.538l.028-.008C10.887,5.967,27.712.994,35.171-.238l.022,0Zm3.9,37.195A2.084,2.084,0,0,0,41.3,34.863V11.88A2.085,2.085,0,0,0,39.217,9.8h-.781V2.333A2.085,2.085,0,0,0,36.353.25H35.335l-.092.007c-7.435,1.23-24.217,6.19-26.107,6.752l-.029.009A2.522,2.522,0,0,0,7.148,9.9v24.96a2.085,2.085,0,0,0,2.083,2.082Zm-3.855-35.8h.991a1.193,1.193,0,0,1,1.192,1.191V9.8H9.231a2.054,2.054,0,0,0-.838.18l-.352.156V9.749A1.6,1.6,0,0,1,9.36,7.874c.168-.052,18.21-5.436,25.981-6.729ZM37.045,9.3V2.333a.692.692,0,0,0-.692-.691H35.4C27.65,2.936,9.674,8.3,9.5,8.353c-.754.22-.917.527-.952,1.038A2.519,2.519,0,0,1,9.231,9.3ZM9.231,10.689H39.217a1.192,1.192,0,0,1,1.191,1.191v8.352H31a2.084,2.084,0,0,0-2.082,2.082v4.637A2.084,2.084,0,0,0,31,29.033h9.4v5.83a1.192,1.192,0,0,1-1.191,1.191H9.231A1.192,1.192,0,0,1,8.04,34.863V11.88A1.192,1.192,0,0,1,9.231,10.689Zm30.677,9.043V11.88a.692.692,0,0,0-.691-.691H9.231a.692.692,0,0,0-.691.691V34.863a.692.692,0,0,0,.691.691H39.216a.692.692,0,0,0,.691-.691v-5.33H31a2.585,2.585,0,0,1-2.582-2.582V22.314A2.585,2.585,0,0,1,31,19.732ZM31,21.123h9.4v7.021H31a1.193,1.193,0,0,1-1.191-1.193V22.314A1.192,1.192,0,0,1,31,21.123Zm8.9.5H31a.692.692,0,0,0-.691.691v4.637a.693.693,0,0,0,.691.693h8.9Z",
    transform: "translate(-6.898)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(24.538 23.576)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1.023,
    cy: 1.023,
    r: 1.023,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_8_-_Outline",
    "data-name": "Ellipse 8 - Outline",
    d: "M1.023-.25A1.273,1.273,0,1,1-.25,1.023,1.274,1.274,0,0,1,1.023-.25Zm0,2.045A.773.773,0,1,0,.25,1.023.774.774,0,0,0,1.023,1.8Z",
    fill: "url(#linear-gradient)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiwWallet);
export default __webpack_public_path__ + "static/media/hiw-wallet.125ce34fa29098e3f78c9359071c24d4.svg";
export { ForwardRef as ReactComponent };